
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Publicacion() { return this.Controlador.Publicacion; }
        public get Articulo() { return this.Controlador.Articulo; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public Descripcion: string = '';
        public Cargando: boolean = false;

        public Ok()
        {
            return this.Descripcion != this.Publicacion.Descripcion;
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Eventos.push( this.Controlador.onRecargarDescripcion.subscribe( x => this.Iniciar() ) );
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( x => this.Iniciar() ) );
            this.Iniciar();
        }

        Iniciar()
        {
            if ( this.Estado != 'iniciado' )
                return;
            this.Descripcion = this.Publicacion.Descripcion;
        }

        async Guardar()
        {
            this.Cargando = true;
            let e = await this.Publicacion.ModificarDescripcion( this.Descripcion );
            if ( !e )
            {
                Utiles.Notificaciones.Error( 'Error al modificar la publicación' );
            }
            this.Cargando = false;
        }

    }
